module.exports = __webpack_public_path__ + "bootleggers_coffee_mockup_kcup_v2.jpg?71313d9efb3110373ab97156c69f3d2a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/portfolio/bootleggers/bootleggers_coffee_mockup_kcup_v2.jpg
// module id = 40
// module chunks = 0